import styled from 'styled-components';

export const FileDrop = styled.div`
  margin: 20px 0px;
`;
